/**
 * 주문 수량 변환
 * @param minimum_order_quantity 최소 구매수량
 * @param maximum_order_quantity 최대 구매수량
 * @returns 변환된 텍스트
 * ex) 1인 최소/최대 구매수량 : 10개/20개
 */
export const orderQuantityTransformer = (minimum_order_quantity: number, maximum_order_quantity: number): string => {
  const text_parts: string[] = [];
  const quantity_parts: string[] = [];

  if (minimum_order_quantity) {
    text_parts.push('최소');
    quantity_parts.push(`${minimum_order_quantity}개`);
  }
  if (maximum_order_quantity) {
    text_parts.push('최대');
    quantity_parts.push(`${maximum_order_quantity}개`);
  }
  const text = text_parts.join('/');
  const quantity = quantity_parts.join('/');

  return `1인 ${text} 구매수량 : ${quantity}`;
};
